export default class AudioFingerprint {

	#context
	#currentTime
	#oscillator
	#compressor
	#callback

	#setup() {
		let audioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
		this.#context = new audioContext(1, 44100, 44100);

		this.#currentTime = this.#context.currentTime;

		this.#oscillator = this.#context.createOscillator();
		this.#oscillator.type = "triangle";
		this.#oscillator.frequency.setValueAtTime(10000, this.#currentTime);

		this.#compressor = this.#context.createDynamicsCompressor();

		this.#setCompressorValueIfDefined('threshold', -50);
		this.#setCompressorValueIfDefined('knee', 40);
		this.#setCompressorValueIfDefined('ratio', 12);
		this.#setCompressorValueIfDefined('reduction', -20);
		this.#setCompressorValueIfDefined('attack', 0);
		this.#setCompressorValueIfDefined('release', .25);
	}

	#setCompressorValueIfDefined(item, value) {
		if (this.#compressor[item] !== undefined && typeof this.#compressor[item].setValueAtTime === 'function') {
			this.#compressor[item].setValueAtTime(value, this.#context.currentTime);
		}
	}

	#onComplete(event) {
		this.#generateFingerprints(event);
		this.#compressor.disconnect();
	}

	#generateFingerprints(event) {
		let output = 0;
		for (let i = 4500; 5e3 > i; i++) {
			let channelData = event.renderedBuffer.getChannelData(0)[i];
			output += Math.abs(channelData);
		}

		return this.#callback(output.toString());
	}

	run(cb) {
		this.#callback = cb;
		try {
			this.#setup();
			this.#oscillator.connect(this.#compressor);
			this.#compressor.connect(this.#context.destination);

			this.#oscillator.start(0);
			this.#context.startRendering();

			this.#context.oncomplete = this.#onComplete.bind(this);

		} catch (e) {
			console.error('Got an error getting the audio fingerprint: ', e)
		}
	}

}
